import { render, staticRenderFns } from "./partsProposal.vue?vue&type=template&id=0b8ffb36&scoped=true"
import script from "./partsProposal.vue?vue&type=script&lang=js"
export * from "./partsProposal.vue?vue&type=script&lang=js"
import style0 from "./partsProposal.vue?vue&type=style&index=0&id=0b8ffb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ffb36",
  null
  
)

export default component.exports